import React, { FC } from 'react';
import { EN_ALPHABET, RU_ALPHABET } from 'common/config';

interface IComponentProps {
  onChange: (value: string) => void;
}

export const BrandCatalogsFilter: FC<IComponentProps> = ({ onChange }) => {
  return (
    <div className="brand-catalogs-filter">
      <div className="mb-4 flex align-center wrap">
        {RU_ALPHABET.map((item) => {
          return (
            <div key={item} className="brand-catalogs-filter__btn" onClick={() => onChange(item)}>
              {item}
            </div>
          );
        })}
      </div>
      <div className="flex align-center wrap">
        {[...EN_ALPHABET, 'other'].map((item) => {
          return (
            <div key={item} className="brand-catalogs-filter__btn" onClick={() => onChange(item)}>
              {item === 'other' ? '123' : item}
            </div>
          );
        })}
      </div>
    </div>
  );
};
